import { gql } from '@apollo/client';

export const fetchAvailablePricingPlans = gql`
  query fetchAvailablePricingPlansPPC($id: String, $filterOptions: [FilterOption], $transactionAccountId: String) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      billingCycle
      availablePricingPlans(filterOptions: $filterOptions) {
        type
        billingFrequency
        id
        currency
        pricingPlanType
        status
        description
        offeringName
        tiers {
          unitAmount
          flatAmount
          floor
          ceiling
        }
        chargeElement
        chargeType
      }
    }
  }
`;
